import useTimeRangePopulator from './useTimeRangePopulator';
import useWeeklyTimeRangeGet from './useWeeklyTimeRangeGet';

export default function useWeeklyPopulator() {
  const getter = useWeeklyTimeRangeGet();
  return useTimeRangePopulator(getter);
}
